/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface SaveStripePurchaseSessionDetailsFailed$Params {
  stripeSessionId: string;
}

export function saveStripePurchaseSessionDetailsFailed(http: HttpClient, rootUrl: string, params: SaveStripePurchaseSessionDetailsFailed$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, saveStripePurchaseSessionDetailsFailed.PATH, 'post');
  if (params) {
    rb.query('stripeSessionId', params.stripeSessionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

saveStripePurchaseSessionDetailsFailed.PATH = '/api/memberships/save-stripe-purchase-session-details-failed';
